import { makeStyles } from "@mui/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useMemo } from "react";

const useStyles = makeStyles({
  root: {
    border: 0,
    color: 'text.primary',
    height: 'auto',
    width: '100%',
    overflow: 'hidden'
  },
  tableHeading: {
    marginLeft: 10,
    marginTop: 10,
  }
});

export const EconomicsNI51101Table2Table = ({ economics }) => {

  // STYLES
  const classes = useStyles();
  const currency = economics?.settings?.currency;

  const rows = useMemo(() => {
    try {
      const data = [];

      ['Proved Developed Producing', 'Proved Developed Non-Producing', 'Proved Undeveloped', 'Total Proved'].forEach(category => {
        data.push({
          id: category,
          npv0BTax: 0,
          npv5BTax: 0,
          npv10BTax: 0,
          npv15BTax: 0,
          npv20BTax: 0,
          npv0ATax: 0,
          npv5ATax: 0,
          npv10ATax: 0,
          npv15ATax: 0,
          npv20ATax: 0,
          netValue: 0
        });
      });

      ['Total Probable', 'Total Proved + Probable'].forEach(category => {
        data.push({
          id: category,
          npv0BTax: Number((economics?.npvNet?.cashflowBTax?.[0] / 1000)?.toFixed(2)),
          npv5BTax: Number((economics?.npvNet?.cashflowBTax?.[1] / 1000)?.toFixed(2)),
          npv10BTax: Number((economics?.npvNet?.cashflowBTax?.[2] / 1000)?.toFixed(2)),
          npv15BTax: Number((economics?.npvNet?.cashflowBTax?.[3] / 1000)?.toFixed(2)),
          npv20BTax: Number((economics?.npvNet?.cashflowBTax?.[4] / 1000)?.toFixed(2)),
          npv0ATax: Number((economics?.npvNet?.cashflowATax?.[0] / 1000)?.toFixed(2)),
          npv5ATax: Number((economics?.npvNet?.cashflowATax?.[1] / 1000)?.toFixed(2)),
          npv10ATax: Number((economics?.npvNet?.cashflowATax?.[2] / 1000)?.toFixed(2)),
          npv15ATax: Number((economics?.npvNet?.cashflowATax?.[3] / 1000)?.toFixed(2)),
          npv20ATax: Number((economics?.npvNet?.cashflowATax?.[4] / 1000)?.toFixed(2)),
          netValue: Number((economics?.npvNet?.cashflowBTax?.[2] / economics?.cashflowNet.reduce((tot, curr) => tot + curr.boe, 0))?.toFixed(2))
        });
      });

      return data;

    } catch (error) {
    };
  }, [economics]);

  const columns = useMemo(() => {
    return [
      {
        field: 'id',
        headerName: 'Category',
        width: 200,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'npv0BTax',
        headerName: `NPV 0% b/ Tax (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'npv5BTax',
        headerName: `NPV 5% b/ Tax (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'npv10BTax',
        headerName: `NPV 10% b/ Tax (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'npv15BTax',
        headerName: `NPV 15% b/ Tax (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'npv20BTax',
        headerName: `NPV 20% b/ Tax (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'npv0ATax',
        headerName: `NPV 0% a/ Tax (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'npv5ATax',
        headerName: `NPV 5% a/ Tax (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'npv10ATax',
        headerName: `NPV 10% a/ Tax (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'npv15ATax',
        headerName: `NPV 15% a/ Tax (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'npv20ATax',
        headerName: `NPV 20% a/ Tax (M ${currency?.toUpperCase()})`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      {
        field: 'netValue',
        headerName: `Net Value b/ Tax (${currency?.toUpperCase()}/boe)`,
        width: 100,
        editable: false,
        sortable: true,
        filterable: true,
        disableColumnMenu: false
      },
      
    ];
  }, [currency]);

  try {

    if (rows) {
      return (
        <div className={classes.root}>
          <DataGrid
            rows={rows}
            columns={columns}
            rowsPerPageOptions={[10,25,50,100]}
            disableSelectionOnClick
            className={classes.table}
            components={{
              Toolbar: GridToolbar,
            }}
            sx={{fontSize: 12}}
            rowHeight={24}
            autoHeight={true}
          />
        </div>
      );
    } else {
      return <></>;
    };

  } catch (error) {
    return <></>
  };

};
